import supabase from "../../../shared/database/supabase";
import { CustomError } from "../../../shared/error/error";

export interface ListNotificationsRes {
  unreadCount: number;
  notifications: NotificationAggregate[];
}

export interface NotificationAggregate {
  id: string;
  user: NotificationAggregateUser;
  message: string;
  read: boolean;
  periciaId?: string;
  createdAt: string;
}

export interface NotificationAggregateUser {
  id: string;
  displayName: string;
}

export const listNotificationsReq = async (): Promise<ListNotificationsRes> => {
  try {
    const { data, error } = await supabase.functions.invoke("list-notifications", {});

    if (error) throw error;
    if (data.error) throw data.error;

    return data;
  } catch (err) {
    const apiError = err as CustomError;
    console.error(`API Error: ${apiError.message}`);

    if (apiError && apiError.code && apiError.message && apiError.toast_message && apiError.http_status_code) {
      throw new CustomError(apiError);
    }

    throw new CustomError({});
  }
};
